import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getSiteConfig, SiteConfig } from '../services/siteConfigService';
import styles from '../styles/rootLanding.module.css';

export default function RootLanding() {
  const [config, setConfig] = useState<SiteConfig | null>(null);

  useEffect(() => {
    let cancelled = false;
    getSiteConfig().then((c) => {
      if (!cancelled) setConfig(c);
    });
    return () => { cancelled = true; };
  }, []);

  const tagline = config?.tagline ?? "Work your steps. Support your recovery. Join a step workshop.";
  const sectionHeading = config?.section_heading ?? "What you'll find here";
  const bullet1 = config?.bullet1 ?? "Step work that sticks with you — Getting Started, Steps 1–12, guided actions, videos, inventories, and progress that saves automatically when you're signed in.";
  const bullet2 = config?.bullet2 ?? "2026 SAA Step Workshop — facilitator-led weekly online step work: interest list, confirm attendance, Zoom link, calendar, and workshop community tools when you're enrolled.";
  const bullet3 = config?.bullet3 ?? "Privacy by design — your step work is encrypted; only you see it unless you choose to share.";

  return (
    <div className={styles.container}>
      <div className={styles.logoRow}>
        <img
          src="/recovery_commons_icon.png"
          alt="Recovery Commons"
          className={styles.logo}
        />
      </div>
      <h1 className={styles.title}>Recovery Commons</h1>
      <p className={styles.tagline}>{tagline}</p>

      <section className={styles.whatIs}>
        <h2 className={styles.whatIsTitle}>{sectionHeading}</h2>
        <ul className={styles.bullets}>
          <li>{bullet1}</li>
          <li>{bullet2}</li>
          <li>{bullet3}</li>
        </ul>
      </section>

      <Link to="/saa" className={styles.programCard}>
        <span className={styles.programName}>SAA</span>
        <span className={styles.programSubtitle}>Sex Addicts Anonymous</span>
      </Link>
      <p className={styles.comingSoon}>
        Open SAA to work your steps. Use the Workshop link in the header to learn about the 2026 step workshop.
      </p>
      <p className={styles.comingSoon}>More programs (e.g. AA) coming later.</p>
    </div>
  );
}
